module.exports = __webpack_public_path__ + "static/media/setting-users.7e306204.jpg";